var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartIconMobile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 195,
    height: 54,
    viewBox: "0 0 195 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.116286 3.8206C-0.428483 1.90496 1.01028 0 3.00187 0L191.058 0C193.049 0 194.488 1.90496 193.943 3.8206L187.585 26.1794C187.432 26.7158 187.432 27.2842 187.585 27.8206L193.943 50.1794C194.488 52.095 193.049 54 191.058 54H3.00187C1.01028 54 -0.428483 52.095 0.116286 50.1794L6.47467 27.8206C6.62722 27.2842 6.62722 26.7158 6.47467 26.1794L0.116286 3.8206Z",
    fill: "url(#paint0_linear_4125_30355)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4125_30355",
    x1: -8.56711,
    y1: 27,
    x2: 202.627,
    y2: 27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ABF1B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAE8DA"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIconMobile);
export default __webpack_public_path__ + "static/media/start_icon_mobile.2ea4bc458218b221bdba56d2b82637c1.svg";
export { ForwardRef as ReactComponent };